import { Grid, Typography } from '@mui/material';
import { useContext } from 'react';
import { basicLaunchEndLabel, hadBasicLaunch } from '../../../../../../../common/domain/submission';
import { formatGraphDateAndTime } from '../../../../../../../common/formatting';
import { prefixGraphUrl } from '../../../../../../../common/util';
import { submissionHadBasicLaunch, submissionHasBasicLaunchExpired } from '../../../../../../helpers/flowHelpers';
import { SubmissionContext } from '../../Context/SubmissionProvider';
import SubmissionStatusBadge from './SubmissionStatusBadge';

const SubmissionOverviewInfo: React.FC = () => {
  const { submission, game } = useContext(SubmissionContext);
  if (!submission) {
    return null;
  }
  const gameCover16x9 = submission.gameCovers?.find((gameCover) => gameCover.size === '16x9');
  const coverImageUrl = gameCover16x9 && gameCover16x9.uploadedFile ? gameCover16x9.uploadedFile.temporaryUrl : null;
  const coverImgSrc = coverImageUrl && prefixGraphUrl(coverImageUrl);

  const { endsOn, hasExpired } = submissionHasBasicLaunchExpired(submission);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container alignItems="center" spacing={2}>
          <Grid item>
            {coverImgSrc && <img src={coverImgSrc} alt={`${submission.gameName}_cover`} style={{ height: 70, borderRadius: 7 }} />}
          </Grid>
          <Grid item>
            <SubmissionStatusBadge submission={submission} />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <Typography variant="body1" fontWeight="medium">
              Category:
            </Typography>
          </Grid>
          <Grid item xs={12} sm={9}>
            <Typography variant="body1">{submission.categoryName}</Typography>
          </Grid>
        </Grid>
      </Grid>

      {submission.submittedOn && (
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <Typography variant="body1" fontWeight="medium">
                Submission date:
              </Typography>
            </Grid>
            <Grid item xs={12} sm={9}>
              <Typography variant="body1">{formatGraphDateAndTime(submission.submittedOn)}</Typography>
            </Grid>
          </Grid>
        </Grid>
      )}

      {game?.addedOn && (
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <Typography variant="body1" fontWeight="medium">
                Published date:
              </Typography>
            </Grid>
            <Grid item xs={12} sm={9}>
              <Typography variant="body1">{formatGraphDateAndTime(game.addedOn)}</Typography>
            </Grid>
          </Grid>
        </Grid>
      )}

      {/* TODO: we set basicLaunchOn and basicLaunchExpiresOn for pre-existing submissions, so we now need to do the following check to hide the Basic Launch date if the game isn't going/hasn't gone through it (not optimal, but figuring out a timestamp cutoff or other conditions to clean the db is a bit too much for now) */}
      {submission.basicLaunchOn && hadBasicLaunch(submission.status) && (
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <Typography variant="body1" fontWeight="medium">
                Basic Launch started on:
              </Typography>
            </Grid>
            <Grid item xs={12} sm={9}>
              <Typography variant="body1">{formatGraphDateAndTime(submission.basicLaunchOn)}</Typography>
            </Grid>
          </Grid>
        </Grid>
      )}

      {submissionHadBasicLaunch(submission.statusChanges) && endsOn && (
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <Typography variant="body1" fontWeight="medium">
                {basicLaunchEndLabel(hasExpired)}:
              </Typography>
            </Grid>
            <Grid item xs={12} sm={9}>
              <Typography variant="body1">{formatGraphDateAndTime(endsOn)}</Typography>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default SubmissionOverviewInfo;
